import React, { useContext } from "react";
import themeContext from "../context/themeContext";
import imgUrl from "../assets/rgba.png";
const MyColumn = (props) => {
  const ctxtheme = useContext(themeContext);
  return (
    <div
      style={{
        background: `rgba(0,0,107, 0.9)`,
        backgroundRepeat: "repeat",
        borderRadius: "1%",
      }}
    >
      <div style={{ color: "white", fontWeight: "bold", padding: "8px" }}>
        {props.title}
      </div>
      <div style={{ background: "#fb304e", height: "4px" }}></div>
      <div style={{ padding: "5px" }}>{props.children}</div>
    </div>
  );
};
export default MyColumn;
